import type { PlaceProfile } from '@/types/google-api.ts';

export enum LookupResultKind {
	MAPS = 'maps',
	NOTFOUND = 'not-found'
}

export type BusinessProfile = PlaceProfile;

export type LookupResult =
	| { kind: LookupResultKind.MAPS; profile: BusinessProfile }
	| { kind: LookupResultKind.NOTFOUND };
